import React from "react";
import { useTranslation } from "react-i18next";


const OurCertificates = () => {
  const { t } = useTranslation("certificates"); // Hook to use translations

  return (
    <div>
      <div className="container-class p-5 md:p-20">
        <h1 className="web-heading-section">Our Certificates{t("our_certificates_title")}</h1>
        <div className="mt-[63px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="certificate1 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate2 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate3 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate4 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate5 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate6 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate7 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
          <div className="certificate8 rounded-2xl w-full overflow-hidden">
            <div className="mt-[348px] pt-[25px] px-4 pb-4 bg-black bg-opacity-50 rounded-b-2xl w-full h-full space-y-3">
              <h2 className="text-[24px] font-medium leading-8">{t("distributor_certificate")}</h2>
              <p className="text-[16px] font-medium leading-5">
                {t("distributor_certificate_description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCertificates;
